import { ParentContextItem } from "@/apis/taxonomy/types";
import { cn } from "@/lib/utils";
import queries from "@/queries";
import { FormControl, FormField } from "@/styles/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/styles/ui/select";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { UseFormReturn } from "react-hook-form";

const AxisSelect = ({
  form,
  workbookId,
  setSelectedAxis,
  fieldName = "parentTagKey",
  roleKey,
  tableId,
}: {
  form: UseFormReturn<any>;
  workbookId: string;
  roleKey: string;
  tableId: string;
  fieldName?: string;
  setSelectedAxis: (axis: ParentContextItem) => void;
}) => {
  const { data, isLoading } = useQuery({
    ...queries.workbook(workbookId!)._ctx.taxonomy()._ctx.roles(roleKey, true)
      ._ctx.axes(tableId),
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="label-1-normal-medium">축</div>
      <div className="flex items-center gap-2 self-stretch w-full">
        <FormField
          control={form.control}
          name={fieldName}
          render={({ field, fieldState }) => (
            <div className="flex flex-col gap-1 w-full">
              <Select
                onValueChange={(value) => {
                  field.onChange(value);
                  setSelectedAxis(
                    data?.axis.find((axis) => axis.key === value)!,
                  );
                }}
              >
                <FormControl>
                  <SelectTrigger
                    className={cn(
                      "data-[state=open]:bg-[#F5F5F5]",
                      fieldState.error ? "border-red-500 border-[1px]" : "",
                    )}
                  >
                    <SelectValue placeholder="구성요소에 알맞는 [축]을 선택하세요." />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {isLoading ? (
                    <SelectItem
                      value="loading"
                      className="hover:bg-neutral-100"
                    >
                      <Loader2 className="w-[9.33px] h-[9.33px] flex-shrink-0 aspect-square animate-spin" />
                    </SelectItem>
                  ) : (
                    data?.axis.map((axis) => {
                      return (
                        <SelectItem
                          key={axis.id}
                          value={axis.key}
                          className="hover:bg-neutral-100"
                        >
                          {axis.label}
                        </SelectItem>
                      );
                    })
                  )}
                </SelectContent>
              </Select>
              {fieldState.error && (
                <div className="caption-2-regular text-red-500 ml-0.5">
                  {fieldState.error.message}
                </div>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default AxisSelect;
